import { AnimatePresence, motion } from 'framer-motion';
import { useChatStore } from '../../stores/chatStore';
import { ChatModalContent } from './ChatModalContent';

/**
 * ChatModal - Visibility wrapper
 * Handles only the open/close state and AnimatePresence
 * All logic is in ChatModalContent to maintain consistent hook order
 */
export function ChatModal() {
    const { isOpen } = useChatStore();

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="fixed inset-0 z-50 flex items-end justify-end p-6 pointer-events-none"
                >
                    <ChatModalContent />
                </motion.div>
            )}
        </AnimatePresence>
    );
}
